export default __webpack_public_path__ + "static/media/image-about-mission-w@2x.ccfd6b44.png";